import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

interface CorrelationIdBadgeProps {
  correlationId: string;
  onClick?: () => void;
  showCopy?: boolean;
}

export default function CorrelationIdBadge({
  correlationId,
  onClick,
  showCopy = true,
}: CorrelationIdBadgeProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    await navigator.clipboard.writeText(correlationId);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <span
      onClick={onClick}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      className={`
        inline-flex items-center gap-1 px-2 py-0.5
        bg-gray-100 text-gray-700 rounded
        font-mono text-xs
        ${onClick ? 'cursor-pointer hover:bg-gray-200' : ''}
        transition-colors
      `}
    >
      <span className="truncate max-w-[120px]">{correlationId}</span>
      {showCopy && (
        <button
          onClick={handleCopy}
          className="p-0.5 hover:bg-gray-300 rounded transition-colors"
          title="Copy correlation ID"
        >
          {copied ? (
            <Check className="w-3 h-3 text-green-600" />
          ) : (
            <Copy className="w-3 h-3" />
          )}
        </button>
      )}
    </span>
  );
}
